import { GeometergeschaeftListComponent } from './geometergeschaeft-list/geometergeschaeft-list.component';
import { GeometergeschaeftSucheComponent } from './geometergeschaeft-suche/geometergeschaeft-suche.component';
import { Routes } from '@angular/router';
import { GeometergeschaeftDetailComponent } from './geometergeschaeft-detail/geometergeschaeft-detail.component';
import { ErweiterungConfigResponse, PermissionResponse } from '../../core/base-api';
import { canActivateAuthorization } from '../../security/authorization.guard';
import { canActivateErweiterung } from '../../security/erweiterung.guard';
import PermissionsEnum = PermissionResponse.PermissionsEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

export const GeometergeschaeftRoutes: Routes = [
  {
    path: 'geometergeschaeft',
    loadChildren: () => routes
  }
];

const routes: Routes = [
  {
    path: '',
    component: GeometergeschaeftSucheComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GEOMETER_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.AV_GESCHAEFT_INTERCAPI],
      breadcrumb: 'Geometergeschäft',
      breadcrumbStatus: 'firstLevel'
    }
  },
  {
    path: 'list/:searchMode',
    component: GeometergeschaeftListComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GEOMETER_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.AV_GESCHAEFT_INTERCAPI],
      breadcrumb: 'Suchergebnis',
      breadcrumbStatus: 'secondLevel'
    }
  },
  {
    path: 'detail/:id',
    component: GeometergeschaeftDetailComponent,
    canActivate: [canActivateAuthorization, canActivateErweiterung],
    data: {
      permissions: [PermissionsEnum.GEOMETER_REGISTER],
      erweiterung: [ActiveErweiterungenEnum.AV_GESCHAEFT_INTERCAPI]
    }
  }
];
